export const WIZARD_HEIGHT = 504;
export const WIZARD_WIDTH = 870;
export const IMAGE_SIZE = 150;
export const PREVIEW_SIZE = 380;
